import { render } from "./PromptLibrary.vue?vue&type=template&id=5d8ee0d0&scoped=true"
import script from "./PromptLibrary.vue?vue&type=script&lang=js"
export * from "./PromptLibrary.vue?vue&type=script&lang=js"

import "./PromptLibrary.vue?vue&type=style&index=0&id=5d8ee0d0&lang=scss&scoped=true"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d8ee0d0"]])

export default __exports__